var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_692)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000 0H0V1000H1000V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.43,
    d: "M813.971 701.562H196.043L427.014 201.676H583L813.971 701.562Z",
    fill: "url(#paint0_linear_351_692)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.562 561.774L190.394 524.448L231.562 515.115",
    stroke: "#fff",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 704.786H202.555C204.258 704.787 205.903 704.166 207.181 703.04C208.46 701.914 209.284 700.361 209.499 698.672L222.614 595.771H133.4L146.516 698.672C146.731 700.36 147.554 701.913 148.832 703.038C150.109 704.164 151.753 704.785 153.455 704.786V704.786Z",
    fill: "#EAD57D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.048 595.774L157.454 690.808C157.668 692.763 158.596 694.571 160.061 695.883C161.525 697.196 163.422 697.922 165.389 697.922H209.6L209.505 698.672C209.29 700.362 208.466 701.915 207.187 703.041C205.909 704.167 204.264 704.787 202.561 704.787H153.461C151.758 704.787 150.113 704.166 148.835 703.04C147.557 701.915 146.733 700.362 146.518 698.672L133.4 595.774H147.048Z",
    fill: "#E5C66E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 704.786H202.555C204.258 704.787 205.903 704.166 207.181 703.04C208.46 701.914 209.284 700.361 209.499 698.672L222.614 595.771H133.4L146.516 698.672C146.731 700.36 147.554 701.913 148.832 703.038C150.109 704.164 151.753 704.785 153.455 704.786V704.786Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.25 675.164L225.593 625.396H130.42L136.763 675.164H219.25Z",
    fill: "#5CBF84"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.25 675.164L225.593 625.396H130.42L136.763 675.164H219.25Z",
    fill: "#4FB277"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.856 669.414L224.175 625.396H144.367L149.267 665.921C149.384 666.884 149.849 667.771 150.575 668.414C151.301 669.058 152.238 669.413 153.208 669.414H218.856Z",
    fill: "#5CBF84"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.25 675.164L225.593 625.396H130.42L136.763 675.164H219.25Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.668 595.773H228.346C234.421 595.773 239.346 590.849 239.346 584.773C239.346 578.698 234.421 573.773 228.346 573.773H127.668C121.593 573.773 116.668 578.698 116.668 584.773C116.668 590.849 121.593 595.773 127.668 595.773Z",
    fill: "#5CBF84"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.668 595.773H228.346C234.421 595.773 239.346 590.849 239.346 584.773C239.346 578.698 234.421 573.773 228.346 573.773H127.668C121.593 573.773 116.668 578.698 116.668 584.773C116.668 590.849 121.593 595.773 127.668 595.773Z",
    fill: "#4FB277"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.044 591.023H230.72C235.483 591.023 239.345 587.162 239.345 582.398C239.345 577.635 235.483 573.773 230.72 573.773H139.044C134.281 573.773 130.419 577.635 130.419 582.398C130.419 587.162 134.281 591.023 139.044 591.023Z",
    fill: "#5CBF84"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.668 595.773H228.346C234.421 595.773 239.346 590.849 239.346 584.773C239.346 578.698 234.421 573.773 228.346 573.773H127.668C121.593 573.773 116.668 578.698 116.668 584.773C116.668 590.849 121.593 595.773 127.668 595.773Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.006 573.774H218.006L216.423 561.774H139.59L138.006 573.774Z",
    fill: "#5CBF84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M139.59 561.774H163.062L157.506 573.774H138.006L139.59 561.774Z",
    fill: "#54AF79"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M138.006 573.774H218.006L216.423 561.774H139.59L138.006 573.774Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M310.7 435.853H648.478C653.017 435.853 657.369 437.656 660.579 440.865C663.788 444.074 665.591 448.427 665.591 452.966V675.853H293.591V452.965C293.591 448.427 295.394 444.075 298.602 440.866C301.811 437.657 306.162 435.854 310.7 435.853V435.853Z",
    fill: "#D2DCE6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M310.7 435.853H648.478C653.017 435.853 657.369 437.656 660.579 440.865C663.788 444.074 665.591 448.427 665.591 452.966V675.853H293.591V452.965C293.591 448.427 295.394 444.075 298.602 440.866C301.811 437.657 306.162 435.854 310.7 435.853V435.853Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M637.591 648.136V464.136H321.591V648.136H637.591Z",
    fill: "#FF5C5C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M631.78 561.585C632.781 561.522 633.774 561.798 634.599 562.368C635.423 562.938 636.032 563.77 636.327 564.728V553.273C635.229 552.952 634.091 552.787 632.947 552.781H631.78C629.264 552.781 628.006 554.039 628.007 556.554V557.9C628.007 560.327 629.264 561.585 631.78 561.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M636.327 616.494C636.027 617.448 635.416 618.273 634.592 618.838C633.767 619.404 632.778 619.677 631.78 619.614C629.264 619.614 628.006 620.871 628.007 623.386V624.734C628.007 627.249 629.265 628.506 631.78 628.507H632.947C634.091 628.502 635.229 628.336 636.327 628.015V616.494Z",
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M637.591 648.136V464.136H321.591V648.136H637.591Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M252.543 676H706.643C707.704 676 708.721 676.421 709.471 677.172C710.222 677.922 710.643 678.939 710.643 680V684.791C710.643 690.095 708.536 695.182 704.785 698.933C701.034 702.684 695.947 704.791 690.643 704.791H268.543C263.239 704.791 258.152 702.684 254.401 698.933C250.65 695.182 248.543 690.095 248.543 684.791V680C248.543 678.939 248.964 677.922 249.715 677.172C250.465 676.421 251.482 676 252.543 676Z",
    fill: "#E5E5E5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M690.639 695.787H268.539C263.743 695.784 259.108 694.056 255.48 690.919C251.852 687.782 249.474 683.445 248.778 678.7C248.627 679.117 248.548 679.557 248.543 680V684.791C248.543 690.096 250.65 695.183 254.401 698.933C258.152 702.684 263.239 704.791 268.543 704.791H690.643C695.947 704.791 701.034 702.684 704.785 698.933C708.536 695.183 710.643 690.096 710.643 684.791V680C710.638 679.557 710.559 679.117 710.408 678.7C709.712 683.447 707.332 687.785 703.703 690.922C700.073 694.059 695.436 695.786 690.639 695.787V695.787Z",
    fill: "#CFD1D0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M252.543 676H706.643C707.704 676 708.721 676.421 709.471 677.172C710.222 677.922 710.643 678.939 710.643 680V684.791C710.643 690.095 708.536 695.182 704.785 698.933C701.034 702.684 695.947 704.791 690.643 704.791H268.543C263.239 704.791 258.152 702.684 254.401 698.933C250.65 695.182 248.543 690.095 248.543 684.791V680C248.543 678.939 248.964 677.922 249.715 677.172C250.465 676.421 251.482 676 252.543 676Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M437.591 675.854H521.591C521.591 677.975 520.748 680.01 519.248 681.51C517.748 683.011 515.713 683.854 513.591 683.854H445.591C443.469 683.854 441.434 683.011 439.934 681.51C438.434 680.01 437.591 677.975 437.591 675.854Z",
    fill: "#686B6D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M437.591 675.854H521.591C521.591 677.975 520.748 680.01 519.248 681.51C517.748 683.011 515.713 683.854 513.591 683.854H445.591C443.469 683.854 441.434 683.011 439.934 681.51C438.434 680.01 437.591 677.975 437.591 675.854Z",
    stroke: "#283035",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M478.804 457.619C483.222 457.619 486.804 454.037 486.804 449.619C486.804 445.201 483.222 441.619 478.804 441.619C474.386 441.619 470.804 445.201 470.804 449.619C470.804 454.037 474.386 457.619 478.804 457.619Z",
    fill: "#686B6D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M478.804 457.619C483.222 457.619 486.804 454.037 486.804 449.619C486.804 445.201 483.222 441.619 478.804 441.619C474.386 441.619 470.804 445.201 470.804 449.619C470.804 454.037 474.386 457.619 478.804 457.619Z",
    stroke: "#283035",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M721.134 704.886C721.179 697.227 724.253 689.897 729.685 684.497C735.117 679.097 742.464 676.066 750.124 676.066C757.783 676.066 765.131 679.097 770.562 684.497C775.994 689.897 779.068 697.227 779.113 704.886H721.134Z",
    fill: "#E5E5E5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M750.124 695.729C754.27 695.769 758.376 694.92 762.166 693.241C765.957 691.562 769.344 689.09 772.1 685.993C769.381 682.826 766.009 680.285 762.216 678.542C758.423 676.8 754.298 675.897 750.123 675.897C745.949 675.897 741.824 676.8 738.031 678.542C734.238 680.285 730.866 682.826 728.147 685.993C730.903 689.091 734.29 691.562 738.081 693.241C741.872 694.921 745.978 695.769 750.124 695.729V695.729Z",
    fill: "#CFD1D0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.923 653.683L150.923 651.737C158.512 657.889 167.985 661.246 177.755 661.246C187.524 661.246 196.997 657.889 204.587 651.737L207.087 654.181",
    stroke: "#283035",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M171.624 643.6C171.624 642.465 171.173 641.376 170.37 640.573C169.567 639.77 168.478 639.319 167.343 639.319V639.319C166.208 639.319 165.119 639.77 164.316 640.573C163.513 641.376 163.062 642.465 163.062 643.6V647.521",
    stroke: "#283035",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184.388 643.6C184.388 642.465 184.839 641.376 185.642 640.573C186.445 639.77 187.534 639.319 188.669 639.319V639.319C189.804 639.319 190.893 639.77 191.696 640.573C192.499 641.376 192.95 642.465 192.95 643.6V647.521",
    stroke: "#283035",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M908.467 693.92L898.562 695.298L904.893 704.513L908.467 693.92Z",
    fill: "#E5E5E5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M908.467 693.92L898.562 695.298L904.893 704.513L908.467 693.92Z",
    stroke: "#283035",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M880.641 574.886H802.841C797.815 574.886 793.741 578.96 793.741 583.986V695.786C793.741 700.812 797.815 704.886 802.841 704.886H880.641C885.667 704.886 889.741 700.812 889.741 695.786V583.986C889.741 578.96 885.667 574.886 880.641 574.886Z",
    fill: "#E5E5E5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M880.641 574.886H879.488C879.654 575.574 879.739 576.278 879.741 576.986V688.786C879.741 691.199 878.782 693.514 877.076 695.22C875.369 696.927 873.054 697.886 870.641 697.886H794C794.472 699.878 795.603 701.652 797.208 702.922C798.813 704.192 800.8 704.884 802.847 704.886H880.647C883.06 704.886 885.375 703.927 887.082 702.22C888.788 700.514 889.747 698.199 889.747 695.786V583.986C889.747 582.79 889.511 581.606 889.054 580.502C888.596 579.398 887.925 578.394 887.08 577.549C886.234 576.704 885.23 576.034 884.125 575.577C883.02 575.12 881.837 574.885 880.641 574.886V574.886Z",
    fill: "#CFD1D0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M880.641 574.886H802.841C797.815 574.886 793.741 578.96 793.741 583.986V695.786C793.741 700.812 797.815 704.886 802.841 704.886H880.641C885.667 704.886 889.741 700.812 889.741 695.786V583.986C889.741 578.96 885.667 574.886 880.641 574.886Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M857.741 567.342H849.741V564.342C849.741 562.22 848.898 560.185 847.398 558.685C845.897 557.185 843.863 556.342 841.741 556.342C839.619 556.342 837.584 557.185 836.084 558.685C834.584 560.185 833.741 562.22 833.741 564.342V567.342H825.741C823.619 567.342 821.584 568.185 820.084 569.685C818.584 571.185 817.741 573.22 817.741 575.342C817.741 577.464 818.584 579.498 820.084 580.999C821.584 582.499 823.619 583.342 825.741 583.342H857.741C859.863 583.342 861.897 582.499 863.398 580.999C864.898 579.498 865.741 577.464 865.741 575.342C865.741 573.22 864.898 571.185 863.398 569.685C861.897 568.185 859.863 567.342 857.741 567.342Z",
    fill: "#F7B66F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M861.458 568.262C861.783 569.447 861.829 570.691 861.593 571.898C861.357 573.104 860.846 574.239 860.099 575.215C859.352 576.191 858.389 576.981 857.286 577.523C856.183 578.066 854.97 578.346 853.741 578.342H821.741C820.446 578.342 819.17 578.027 818.024 577.423C818.481 579.12 819.485 580.62 820.88 581.69C822.275 582.759 823.983 583.34 825.741 583.342H857.741C859.528 583.34 861.264 582.74 862.67 581.637C864.076 580.534 865.073 578.992 865.501 577.256C865.928 575.521 865.763 573.692 865.03 572.062C864.297 570.432 863.04 569.094 861.458 568.262Z",
    fill: "#EDA762"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M845.741 559.342V562.342H849.479C849.2 561.261 848.698 560.251 848.006 559.376C847.313 558.502 846.445 557.781 845.458 557.262C845.644 557.94 845.739 558.639 845.741 559.342V559.342Z",
    fill: "#EDA762"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M857.741 567.342H849.741V564.342C849.741 562.22 848.898 560.185 847.398 558.685C845.897 557.185 843.863 556.342 841.741 556.342C839.619 556.342 837.584 557.185 836.084 558.685C834.584 560.185 833.741 562.22 833.741 564.342V567.342H825.741C823.619 567.342 821.584 568.185 820.084 569.685C818.584 571.185 817.741 573.22 817.741 575.342C817.741 577.464 818.584 579.498 820.084 580.999C821.584 582.499 823.619 583.342 825.741 583.342H857.741C859.863 583.342 861.897 582.499 863.398 580.999C864.898 579.498 865.741 577.464 865.741 575.342C865.741 573.22 864.898 571.185 863.398 569.685C861.897 568.185 859.863 567.342 857.741 567.342Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M841.741 612.342C846.343 612.342 850.074 608.611 850.074 604.009C850.074 599.407 846.343 595.676 841.741 595.676C837.139 595.676 833.408 599.407 833.408 604.009C833.408 608.611 837.139 612.342 841.741 612.342Z",
    fill: "#8EAFBF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M841.741 612.342C846.343 612.342 850.074 608.611 850.074 604.009C850.074 599.407 846.343 595.676 841.741 595.676C837.139 595.676 833.408 599.407 833.408 604.009C833.408 608.611 837.139 612.342 841.741 612.342Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M809.964 629.676H829.964",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M809.964 656.842H829.964",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M809.964 684.009H829.964",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M843.178 628.606L848.392 635.541L863.996 623.811",
    stroke: "#8BAFC1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M843.178 655.772L848.392 662.708L863.996 650.977",
    stroke: "#8BAFC1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M899.644 630.532L889.74 631.91L898.561 695.299L908.465 693.921L899.644 630.532Z",
    fill: "#3BBC88"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M899.644 630.532L889.74 631.91L898.561 695.299L908.465 693.921L899.644 630.532Z",
    stroke: "#283035",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M895.986 620.463L890.046 621.291L891.426 631.191L897.366 630.363L895.986 620.463Z",
    fill: "#E5E5E5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M895.986 620.463L890.046 621.291L891.426 631.191L897.366 630.363L895.986 620.463Z",
    stroke: "#283035",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M908.6 655.545C907.48 653.7 906.686 651.676 906.253 649.561C905.148 644.128 907.876 641.022 906.401 637.93C905.813 636.697 905.528 635.013 901.111 634.375",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M920.75 704.886H946.5",
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M234.333 704.886H909.5",
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M114.75 704.886H222.616",
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M80.333 704.886H103.5",
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M505.007 227.582C518.262 227.582 529.007 216.837 529.007 203.582C529.007 190.327 518.262 179.582 505.007 179.582C491.752 179.582 481.007 190.327 481.007 203.582C481.007 216.837 491.752 227.582 505.007 227.582Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M436.111 209C434.89 208.996 433.684 208.733 432.573 208.229C431.461 207.724 430.469 206.99 429.662 206.074C428.856 205.158 428.252 204.081 427.892 202.915C427.532 201.749 427.423 200.519 427.573 199.308C432.238 159.7 465.127 129 505.007 129C544.887 129 577.776 159.7 582.44 199.308C582.59 200.52 582.481 201.749 582.121 202.916C581.761 204.082 581.157 205.159 580.35 206.075C579.543 206.991 578.551 207.725 577.439 208.23C576.327 208.734 575.121 208.996 573.9 209H436.111Z",
    fill: "#F7B66F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M517.007 129.944C516.749 129.903 516.488 129.874 516.229 129.836C515.32 129.702 514.406 129.581 513.487 129.479C513.069 129.432 512.65 129.394 512.23 129.354C511.468 129.282 510.705 129.217 509.941 129.173C509.497 129.147 509.056 129.114 508.611 129.093C507.416 129.037 506.211 129 505.011 129C503.811 129 502.611 129.036 501.423 129.093C500.874 129.119 500.329 129.162 499.783 129.199C499.193 129.24 498.603 129.282 498.016 129.337C497.296 129.402 496.58 129.48 495.866 129.566C495.517 129.608 495.166 129.655 494.822 129.702C458.798 134.525 430.495 164.538 427.31 201.951C427.231 202.845 427.338 203.746 427.626 204.597C427.913 205.447 428.375 206.229 428.98 206.891C429.586 207.554 430.322 208.084 431.143 208.447C431.965 208.81 432.852 208.998 433.75 209H576.268C577.158 209.003 578.039 208.821 578.856 208.466C579.672 208.112 580.407 207.592 581.012 206.94C581.618 206.287 582.082 205.517 582.376 204.676C582.669 203.836 582.785 202.944 582.717 202.056C579.629 165.22 552.2 135.518 517.007 129.944ZM454.031 186.929C457.432 174.568 463.78 163.216 472.53 153.846C481.28 144.476 492.172 137.368 504.271 133.129C516.381 137.359 527.284 144.464 536.044 153.835C544.804 163.206 551.159 174.562 554.565 186.929C554.997 188.527 555.055 190.204 554.733 191.828C554.411 193.452 553.719 194.981 552.711 196.294C551.702 197.607 550.404 198.67 548.918 199.399C547.431 200.129 545.797 200.505 544.141 200.5H464.456C462.8 200.506 461.165 200.129 459.678 199.4C458.192 198.67 456.894 197.608 455.885 196.295C454.876 194.981 454.184 193.453 453.862 191.829C453.541 190.204 453.598 188.527 454.031 186.929V186.929Z",
    fill: "#EFAA65"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M436.178 209C434.949 208.997 433.734 208.732 432.614 208.225C431.494 207.717 430.495 206.978 429.682 206.055C428.869 205.133 428.262 204.049 427.899 202.874C427.536 201.699 427.427 200.461 427.578 199.241C432.275 159.661 465.15 129 505.007 129C544.864 129 577.739 159.661 582.432 199.241C582.583 200.461 582.474 201.699 582.111 202.874C581.749 204.049 581.141 205.133 580.328 206.056C579.515 206.978 578.516 207.718 577.396 208.225C576.276 208.733 575.061 208.997 573.832 209H436.178Z",
    stroke: "#283035",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M505.007 0V129",
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_351_692",
    x1: 505.007,
    y1: 194.725,
    x2: 505.007,
    y2: 719.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "white",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "white",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "white",
    stopOpacity: 0.389
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "white",
    stopOpacity: 0.221
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "white",
    stopOpacity: 0.026
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMh);
export default __webpack_public_path__ + "static/media/mh.daf1ac91d206be6e0b95a43e1922fe78.svg";
export { ForwardRef as ReactComponent };